const BASE = process.env.REACT_APP_BACKEND_URL;

export const api = (path) => `${BASE}/api${path}`;

export const TEMI = [
    { id: "store", label: "Store" },
    { id: "acquisizione", label: "Acquisizione" },
    { id: "lead", label: "Lead" },
    { id: "contenuti", label: "Contenuti" },
    { id: "gestione", label: "Gestione" },
    { id: "metodo", label: "Metodo" },
];
export const temaLabel = (id) => TEMI.find((t) => t.id === id)?.label || "";

const adminAuth = () => {
    try {
        const t = localStorage.getItem("apf-admin");
        return t ? { Authorization: `Bearer ${t}` } : {};
    } catch {
        return {};
    }
};

export const fetchRelated = async (slug) => {
    const res = await fetch(api(`/posts/${slug}/related`));
    return res.ok ? res.json() : [];
};

export const fetchPosts = async (limit = 50, tema = "") => {
    const res = await fetch(api(`/posts?limit=${limit}${tema ? `&tema=${tema}` : ""}`));
    if (!res.ok) throw new Error("posts");
    return res.json();
};

export const fetchPost = async (slug) => {
    const res = await fetch(api(`/posts/${slug}`), { headers: adminAuth() });
    if (res.status === 404) return null;
    if (!res.ok) throw new Error("post");
    return res.json();
};

// URL immagini: le relative (/api/uploads/...) passano dal backend
export const mediaUrl = (src) =>
    src && src.startsWith("/api/") ? `${BASE}${src}` : src;

const MESI = [
    "Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno",
    "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre",
];
export const formatDate = (iso) => {
    const [y, m, d] = iso.split("-").map(Number);
    return d ? `${d} ${MESI[m - 1]} ${y}` : `${MESI[m - 1]} ${y}`;
};
export const formatRead = (min) => `${min} min di lettura`;
